export default __webpack_public_path__ + "static/media/23.bfd8c635.jpg";